import { render, staticRenderFns } from "./ModalConfigurarDepreciacaoForm.vue?vue&type=template&id=3b19a067"
import script from "./ModalConfigurarDepreciacaoForm.vue?vue&type=script&lang=js"
export * from "./ModalConfigurarDepreciacaoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports